const admission = {
  'admission-add': 'Add Admission',
  'admission-add-header': 'Add Data Admission',
  'admission-additional-service': 'Additional Service',
  'admission-age': 'Age',
  'admission-billing': 'Billing to',
  'admission-billing-placeholder': 'Select Billing to',
  'admission-branch': 'Branch',
  'admission-branchAlias': 'Branch Alias',
  'admission-client': 'Client',
  'admission-partner': 'Partner',
  'admission-client-type': 'Client Type',
  'admission-client-location': 'Client Location',
  'admission-client-location-placeholder': 'Select Client Location',
  'admission-client-placeholder': 'Select Client',
  'admission-deleted': 'Deleted',
  'admission-department': 'Department',
  'admission-division': 'Division',
  'admission-rsv': 'Reservation Patient',
  'admission-norsv': 'Non Reservation Patient',
  'admission-dob': 'Date of Birth',
  'admission-email': 'Email',
  'admission-employee': 'Employee Number',
  'admission-employee-id': 'Employee ID',
  'admission-mcu-location': 'MCU Location',
  'admission-export': 'Export Registration',
  'admission-finished': 'Finished',
  'admission-failed': 'Failed',
  'admission-inqueue': 'In Queue',
  'admission-form-header-1': 'MCU Info',
  'admission-form-header-2': 'Personal Info',
  'admission-form-header-3': 'Employee MCU Info',
  'admission-rangedate': 'Range Date',
  'admission-filter-by': 'Filter By',
  'admission-filter-by-placeholder': 'Select Filter By',
  'admission-gender': 'Gender',
  'admission-header': 'Admission',
  'admission-gender-placeholder': 'Select Gender',
  'admission-grade': 'Grade',
  'admission-guarantee-ln': 'Guarantee Letter Number',
  'admission-hard-copy': 'Hard Copy Result Delivery',
  'admission-hard-copy-placeholder': 'Select Hard Copy Result Delivery',
  'admission-identity-type': 'Identity Type',
  'admission-identity-type-placeholder': 'Select Identity Type',
  'admission-identity-number': 'Identity Number',
  'admission-job-category': 'Job Category',
  'admission-lang': 'Language',
  'admission-mcu': 'MCU No',
  'admission-mr': 'MR No',
  'admission-mr-number': 'MR Number',
  'admission-mr-number-placeholder': 'Select MR Number',
  'admission-mr-patient-name': 'MR Patient Name',
  'admission-mcu-package': 'MCU Package',
  'admission-mcu-package-placeholder': 'Select MCU Package',
  'admission-mcu-type': 'MCU Type',
  'admission-note': 'Note',
  'admission-onprocess': 'On Process',
  'admission-package': 'Package',
  'admission-package-additional-info': 'Package Additional Info',
  'admission-phone': 'Mobile Phone',
  'admission-patient': 'Patient Name',
  'admission-position': 'Position',
  'admission-patient-type': 'Patient Type',
  'admission-patient-type-placeholder': 'Select Patient Type',
  'admission-photo-patient': 'Photo Patient',
  'admission-pob': 'Place of Birth',
  'admission-project-name': 'Project Name',
  'admission-reg': 'Patient Reg. No',
  'admission-rsvp': 'RSVP Patient',
  'admission-rsvp-placeholder': 'Select RSVP Patient',
  'admission-rsvp-no': 'RSVP Patient Number',
  'admission-rsvpNumber': 'RSVP No',
  'admission-rsvp-no-placeholder': 'Select RSVP Patient Number',
  'admission-rsvp-no-placeholder-2': 'Select Patient Reservation',
  'admission-status': 'Status',
  'admission-unit': 'Unit',
  'admission-waiting': 'Waiting For Payment',
  admission: {
    registrationPatient: {
      patientRegNo: 'Patient Reg. No',
      patientName: 'Patient Name',
      visitDate: 'Visit Date',
      product: 'Product',
      action: 'Action',
      identityNumber: 'Identity Number',
      gender: 'Gender',
      dob: 'Date of Birth',
      phone: 'Mobile Phone',
      email: 'Email',
      note: 'Note'
    },
    form: {
      additionalInfo1: 'Additional Info 1',
      additionalInfo2: 'Additional Info 2',
      additionalInfo3: 'Additional Info 3',
      additionalInfo4: 'Additional Info 4',
      additionalInfo5: 'Additional Info 5',
      visitDate: 'Visit Date'
    },
    confirmLeaveTitle: 'Confirm Leave Page',
    confirmEditTitle: 'Confirm Edit Admission',
    confirmLeave:
      'Are you sure want to leave this page? Changes that you made may not be saved',
    titleAdvanceSearchRSVP: 'Advance Search Data RSVP Patient Number',
    titleAdvanceSearchRSVPPartner: 'Advance Search Reservation Data',
    modalConfirmEdit: {
      title: 'Confirm Save',
      body: `The changes data will not update the master data patient.`
    },
    modalConfirmSave: {
      title: 'Confirm Save Add',
      body: 'The changes to the existing data patient will not be updated directly to master data patient.'
    },
    modalPrintHistoryResult: {
      columns: {
        mrNumber: 'MR No.',
        patientRegNo: 'Product Reg No',
        patientName: 'Patient Name',
        dateOfBirth: 'Date of Birth',
        patientCategory: 'Patient Category',
        visitDate: 'Visit Date'
      }
    },
    formNav: {
      btn1: 'Patient MCU Info',
      btn2: 'Address Info',
      btn3: 'Patient Additional Info',
      btn4: 'Emergency Contact'
    },
    modalRSVP: {
      column: {
        no: 'No',
        rsvp: 'RSVP No',
        mrNumber: 'MR Number',
        dob: 'Date of Birth',
        remarks: 'Remarks',
        name: 'Patient Name',
        identityNumber: 'Identity Number',
        gender: 'Gender',
        employeeNumber: 'Employee Number',
        package: 'Package'
      }
    },
    modalDelete: {
      reason: 'Reason'
    },
    modalPrintMCULabel: {
      header: 'Print MCU Label',
      column: {
        printDetailNumber: 'Print Detail Number',
        qty: 'Qty'
      }
    },
    confirmUpdatePrice: {
      title: 'Confirm Update Price',
      body: 'Are you sure want to update the price?'
    },
    modalAdditionalService: {
      selectPackageAdditionalService: 'Select Package Additional Service',
      selectAdditionalService: 'Select Additional Service',
      column: {
        packageAdditionalService: 'Package Additional Service',
        serviceClassification: 'Service Classification',
        additionalService: 'Additional Service',
        quantity: 'Quantity',
        price: 'Price',
        pricePerQty: 'Price (/Qty)',
        totalPrice: 'Total Price'
      }
    },
    modalAdditionalInfo: {
      selectPackageAdditionalInfo: 'Select Package Additional Info',
      column: {
        packageAdditionalInfo: 'Package Additional Info'
      }
    },
    modalConfirmMR: {
      title: 'Confirm MR Number',
      content:
        'The selected patient reservation is identified as existing patient',
      mrNumber: 'MR Number',
      name: 'Patient Name',
      dob: 'Date of Birth',
      note: 'Do you want to use it to autofill the admission form?'
    },
    table: {
      button: {
        printLabel: 'Print MCU Label',
        printForm: 'Print MCU Form'
      }
    }
  }
}

export default admission
